export default __webpack_public_path__ + "static/media/regulations.699de858.svg";